module.exports = __webpack_public_path__ + "static/christmas_family_tree.929efae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project3/christmas_family_tree.jpg
// module id = 506
// module chunks = 142966368958528